import TopBar from './components/TopBar';
import HeroBoard from './components/HeroBoard';
import HotRank from './components/HotRank';
import CardStream from './components/CardStream';
import CommentBoard from './components/CommentBoard';
import FaqBoard from './components/FaqBoard';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="w-full bg-background-50 min-h-screen">
      <TopBar />
      <main>
        <HeroBoard />
        <HotRank />
        <CardStream />
        <CommentBoard />
        <FaqBoard />
      </main>
      <SiteFooter />
    </div>
  );
}